var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"app-card",class:[_vm.data.staticClass, {'app-card__error': _vm.props.error}]},[(_vm.props.errorMessages)?_c('p',{staticClass:"app-card__error-text"},[_vm._v(_vm._s(_vm.props.errorMessages))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }